import { useParams, useNavigate } from 'react-router-dom';
import { config } from "../../data/config";
import { getCookies } from "cookies-next";
import axios from "axios";
import { useEffect, useState, useCallback, useRef, useMemo } from "react";
import BreadCrump from "../tools/breadcrump";
import MapPicker from "./MapPicker";
import HeaderOfPage from "../tools/headerOfPage";
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import CurrencyInput from 'react-currency-input-field';
import ImageUploader from '../tools/uploaderImage';
import ImageUploaders from '../tools/uploaderimages';
import VideoUploaders from '../tools/chunkupload';
import DocumentsUploader from '../tools/uploaderfiles';
import TissEditor from '../Editor/TissEditor';
import { Tabs } from 'rsuite';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
    ClassicEditor,
    Essentials,
    Bold,
    Italic,
    Underline,
    Strikethrough,
    Heading,
    Paragraph,
    Link,
    List,
    Alignment,
    FontSize,
    FontFamily,
    FontColor,
    FontBackgroundColor,
    BlockQuote,
    HorizontalLine,
    RemoveFormat,
    SourceEditing,
    Table,
    TableToolbar,
    TableProperties,
    TableCellProperties,
    Undo
} from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';

const inputstyle = "py-2.5 px-3 block w-full border border-gray-200 dark:border-gray-600 rounded-lg text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition-all disabled:opacity-50 disabled:pointer-events-none bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100";

const CURRENCY_OPTIONS = [
    { value: 'USD', label: 'US Dollar ($)', prefix: '$', decimalsLimit: 2 },
    { value: 'EUR', label: 'Euro (€)', prefix: '€', decimalsLimit: 2 },
    { value: 'TRY', label: 'Turkish Lira (₺)', prefix: '₺', decimalsLimit: 2 },
    { value: 'IRR', label: 'Iranian Toman (تومان)', suffix: ' تومان', decimalsLimit: 0 },
    { value: 'AED', label: 'UAE Dirham (د.إ)', prefix: 'د.إ ', decimalsLimit: 2 }
];
const textareastyle = "py-2.5 px-3 block w-full border border-gray-200 dark:border-gray-600 rounded-lg text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition-all disabled:opacity-50 disabled:pointer-events-none bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 min-h-[100px] resize-y";

const TYPE_OPTIONS = ['Residential', 'Commercial', 'Mixed-Use', 'Industrial', 'Land', 'Other'];

const AVAILABILITY_MODEL_TYPES = ['Apartment', 'MarketPlace', 'Villa', 'Office', 'Shop', 'Warehouse', 'Land', 'Other'];

const defaultMultilingual = { ku: '', fa: '', en: '', ar: '', tr: '' };
const emptyMeterSale = () => ({
    enabled: false,
    method: 'investment',
    totalMeters: 0,
    minMeters: 4,
    contract: {
        title: { ...defaultMultilingual },
        body: { ...defaultMultilingual },
        version: 1
    }
});

const STATUS_OPTIONS = [
    'Permit Application Submitted',
    'Permit Approved',
    'Pre-Construction',
    'Site Preparation',
    'Foundation Work',
    'Structural Construction',
    'Exterior & Roofing',
    'MEP Installation',
    'Interior Finishing',
    'Final Inspection',
    'Ready for Handover',
    'Delivered / Completed'
];

const MONTHS = [
    { value: 1, label: 'January' },
    { value: 2, label: 'February' },
    { value: 3, label: 'March' },
    { value: 4, label: 'April' },
    { value: 5, label: 'May' },
    { value: 6, label: 'June' },
    { value: 7, label: 'July' },
    { value: 8, label: 'August' },
    { value: 9, label: 'September' },
    { value: 10, label: 'October' },
    { value: 11, label: 'November' },
    { value: 12, label: 'December' }
];

export default function EditProperty() {
    const { t } = useTranslation();
    const { Id } = useParams();
    const navigate = useNavigate();
    const cookie = getCookies();
    const isNew = Id === 'new' || Id === undefined;
    const invalidId = !isNew && (Id === 'undefined' || !Id);

    const [data, setData] = useState<any>({
        title: { ...defaultMultilingual },
        code: '',
        city: '',
        agent: '',
        status: 'Permit Application Submitted',
        overview: { ...defaultMultilingual },
        facilities: [],
        mapLocation: { latitude: '', longitude: '', address: '' },
        type: 'Residential',
        deliveryDate: { month: null, year: null },
        startingPrice: 0,
        priceUnit: 'USD',
        active: true,
        arranged: 1,
        availabilityModels: [],
        attributeValues: {},
        meterSale: emptyMeterSale()
    });
    const [loading, setLoading] = useState(!isNew && !invalidId);
    const [languages, setLanguages] = useState<Array<{ code: string; label: string }>>([
        { code: 'ku', label: 'Kurdish' },
        { code: 'fa', label: 'فارسی' },
        { code: 'en', label: 'English' },
        { code: 'ar', label: 'العربية' },
        { code: 'tr', label: 'Türkçe' }
    ]);
    const [cities, setCities] = useState<any[]>([]);
    const [agents, setAgents] = useState<any[]>([]);
    const [facilities, setFacilities] = useState<any[]>([]);
    const [attributes, setAttributes] = useState<any[]>([]);

    const handleMapLocationChange = useCallback((lat: number, lng: number) => {
        setData((prev: any) => ({
            ...prev,
            mapLocation: { ...prev.mapLocation, latitude: String(lat), longitude: String(lng) }
        }));
    }, []);

    const geocodeCity = useCallback(async (cityId: string) => {
        if (!cityId) return;
        const cityObj = cities.find((c: any) => c._id === cityId);
        if (!cityObj) return;
        const cityName = getCityName(cityObj) || cityObj?.code || '';
        if (!cityName.trim()) return;
        try {
            const query = encodeURIComponent(`${cityName.trim()}, Iraq`);
            const res = await fetch(
                `https://nominatim.openstreetmap.org/search?q=${query}&format=json&limit=1`,
                { headers: { 'User-Agent': 'Newaz-RealEstate-Admin/1.0' } }
            );
            const results = await res.json();
            if (Array.isArray(results) && results.length > 0) {
                const { lat, lon } = results[0];
                setData((prev: any) => ({
                    ...prev,
                    mapLocation: {
                        ...prev.mapLocation,
                        latitude: String(lat),
                        longitude: String(lon),
                        address: results[0]?.display_name || prev.mapLocation?.address || ''
                    }
                }));
            }
        } catch (_) {}
    }, [cities]);

    const breadcrump = [
        { name: t('Dashboard'), url: '/dashboard' },
        { name: t('Real Estate System'), url: '/dashboard/RealEstate' },
        { name: t('Property Management'), url: '/dashboard/RealEstate/properties' },
        { name: isNew ? t('Add Property') : t('Edit Property'), url: null },
    ];

    const loadLanguages = async () => {
        try {
            const res = await axios.get(`${config.url}/v1/language`);
            const list = res.data?.message ?? [];
            const mapped = (Array.isArray(list) ? list : [])
                .filter((l: any) => l.active)
                .sort((a: any, b: any) => (a.arranged ?? 0) - (b.arranged ?? 0))
                .map((l: any) => ({ code: l.code, label: l.label || l.code }));
            if (mapped.length > 0) setLanguages(mapped);
        } catch (_) {}
    };

    const loadCities = async () => {
        try {
            const res = await axios.get(`${config.url}/v1/dashboard/realestate/cities`, {
                headers: { Authorization: 'Bearer ' + cookie['token'] }
            });
            setCities(Array.isArray(res.data.message) ? res.data.message : []);
        } catch (_) {
            setCities([]);
        }
    };

    const loadAgents = async () => {
        try {
            const res = await axios.get(`${config.url}/v1/dashboard/realestate/agents`, {
                headers: { Authorization: 'Bearer ' + cookie['token'] }
            });
            setAgents(Array.isArray(res.data.message) ? res.data.message : []);
        } catch (_) {
            setAgents([]);
        }
    };

    const loadFacilities = async () => {
        try {
            const res = await axios.get(`${config.url}/v1/dashboard/realestate/facilities`, {
                headers: { Authorization: 'Bearer ' + cookie['token'] }
            });
            setFacilities(Array.isArray(res.data.message) ? res.data.message : []);
        } catch (_) {
            setFacilities([]);
        }
    };

    const loadAttributes = async () => {
        try {
            const res = await axios.get(`${config.url}/v1/dashboard/realestate/attributes`, {
                headers: { Authorization: 'Bearer ' + cookie['token'] }
            });
            setAttributes(Array.isArray(res.data.message) ? res.data.message : []);
        } catch (_) {
            setAttributes([]);
        }
    };

    const loadedIdRef = useRef<string | undefined>(undefined);

    const load = useCallback(async () => {
        if (isNew || invalidId) return;
        try {
            const res = await axios({
                method: 'get',
                url: `${config.url}/v1/dashboard/realestate/properties/${Id}`,
                headers: { Authorization: 'Bearer ' + cookie['token'] }
            });
            const msg = res.data.message || res.data;
            const title = msg.title && typeof msg.title === 'object'
                ? { ...defaultMultilingual, ...msg.title }
                : { ...defaultMultilingual, en: String(msg.title || '') };
            const overview = msg.overview && typeof msg.overview === 'object'
                ? { ...defaultMultilingual, ...msg.overview }
                : { ...defaultMultilingual, en: String(msg.overview || '') };
            
            setData({
                title,
                code: msg.code || '',
                city: msg.city?._id || msg.city || '',
                agent: msg.agent?._id || msg.agent || '',
                status: msg.status || 'Permit Application Submitted',
                overview,
                facilities: Array.isArray(msg.facilities) ? msg.facilities.map((f: any) => f._id || f) : [],
                mapLocation: msg.mapLocation || { latitude: '', longitude: '', address: '' },
                type: msg.type || 'Residential',
                deliveryDate: msg.deliveryDate || { month: null, year: null },
                startingPrice: msg.startingPrice != null ? Number(msg.startingPrice) : 0,
                priceUnit: msg.priceUnit || 'USD',
                active: msg.active !== false,
                arranged: msg.arranged != null ? Number(msg.arranged) : 1,
                availabilityModels: Array.isArray(msg.availabilityModels)
                    ? [...msg.availabilityModels]
                        .sort((a: any, b: any) => (a.arranged ?? 0) - (b.arranged ?? 0))
                        .map((m: any) => ({
                            type: m.type || 'Apartment',
                            model: m.model ?? '',
                            arranged: m.arranged != null ? Number(m.arranged) : 1,
                            size: m.size ?? '',
                            price: m.price != null ? Number(m.price) : 0
                        }))
                    : [],
                attributeValues: msg.attributeValues && typeof msg.attributeValues === 'object'
                    ? { ...msg.attributeValues }
                    : {},
                meterSale: {
                    ...emptyMeterSale(),
                    ...(msg.meterSale || {}),
                    method: msg.meterSale?.method || 'investment',
                    totalMeters: msg.meterSale?.totalMeters != null ? Number(msg.meterSale.totalMeters) : 0,
                    minMeters: msg.meterSale?.minMeters != null ? Number(msg.meterSale.minMeters) : 4,
                    contract: {
                        title: { ...defaultMultilingual, ...(msg.meterSale?.contract?.title || {}) },
                        body: { ...defaultMultilingual, ...(msg.meterSale?.contract?.body || {}) },
                        version: msg.meterSale?.contract?.version || 1
                    }
                }
            });
        } catch (_) {
            Swal.fire(t("Error"), t("Could not load property."), "error");
        } finally {
            setLoading(false);
        }
    }, [Id, isNew, invalidId, cookie?.['token']]);

    useEffect(() => {
        loadLanguages();
        loadCities();
        loadAgents();
        loadFacilities();
        loadAttributes();
    }, []);

    useEffect(() => {
        if (isNew || invalidId) return;
        if (loadedIdRef.current === Id) return;
        loadedIdRef.current = Id;
        load();
    }, [Id, isNew, invalidId, load]);

    const setMultilingualField = (field: string, lang: string, value: string) => {
        setData((prev: any) => ({
            ...prev,
            [field]: { ...prev[field], [lang]: value }
        }));
    };

    const translateText = async (text: string, fromLang: string, toLang: string): Promise<string> => {
        if (!text || String(text).trim() === '') return '';
        try {
            const response = await fetch(
                `https://translate.googleapis.com/translate_a/single?client=gtx&sl=${fromLang}&tl=${toLang}&dt=t&q=${encodeURIComponent(text)}`
            );
            if (!response.ok) return '';
            const result = await response.json();
            const translated = result[0]?.map((s: any) => s?.[0] || '').join('').trim();
            return translated || text;
        } catch (_) {
            return '';
        }
    };

    const handleAutoTranslate = async () => {
        const langCodes = languages.map(l => l.code);
        const hasTitle = (lang: string) => (data.title?.[lang] || '').trim();
        const hasOverview = (lang: string) => (data.overview?.[lang] || '').trim();
        const sourceLang = langCodes.find(lang => hasTitle(lang) || hasOverview(lang));
        if (!sourceLang) {
            Swal.fire(t('No content to translate'), t('Fill in Title or Overview in at least one language first.'), 'info');
            return;
        }
        const sourceTitle = hasTitle(sourceLang);
        const sourceOverview = hasOverview(sourceLang);
        if (!sourceTitle && !sourceOverview) {
            Swal.fire(t('No content to translate'), t('Fill in Title or Overview in at least one language first.'), 'info');
            return;
        }

        const result = await Swal.fire({
            title: t('Auto translate to all other languages'),
            text: t('This will translate Title and Overview from the first filled language to all other languages. Continue?'),
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: t('Yes, translate'),
            cancelButtonText: t('Cancel')
        });
        if (!result.isConfirmed) return;

        const updatedTitle = { ...(data.title || {}) };
        const updatedOverview = { ...(data.overview || {}) };
        const otherLangs = langCodes.filter(l => l !== sourceLang);

        for (const toLang of otherLangs) {
            if (sourceTitle) {
                const translated = await translateText(sourceTitle, sourceLang, toLang);
                if (translated) updatedTitle[toLang] = translated;
                await new Promise(r => setTimeout(r, 120));
            }
            if (sourceOverview) {
                const translated = await translateText(sourceOverview, sourceLang, toLang);
                if (translated) updatedOverview[toLang] = translated;
                await new Promise(r => setTimeout(r, 150));
            }
        }

        setData((prev: any) => ({
            ...prev,
            title: updatedTitle,
            overview: updatedOverview
        }));
        Swal.fire(t('Done'), t('Content has been translated to all other languages'), 'success');
    };

    const toggleFacility = (facilityId: string) => {
        setData((prev: any) => {
            const current = prev.facilities || [];
            const index = current.indexOf(facilityId);
            if (index > -1) {
                return { ...prev, facilities: current.filter((id: string) => id !== facilityId) };
            } else {
                return { ...prev, facilities: [...current, facilityId] };
            }
        });
    };

    const availabilityModels = Array.isArray(data.availabilityModels) ? data.availabilityModels : [];
    const addAvailabilityModel = () => {
        setData((prev: any) => ({
            ...prev,
            availabilityModels: [...(prev.availabilityModels || []), { type: 'Apartment', model: '', arranged: (prev.availabilityModels?.length ?? 0) + 1, size: '', price: 0 }]
        }));
    };
    const removeAvailabilityModel = (index: number) => {
        setData((prev: any) => ({
            ...prev,
            availabilityModels: (prev.availabilityModels || []).filter((_: any, i: number) => i !== index)
        }));
    };
    const updateAvailabilityModel = (index: number, field: string, value: any) => {
        setData((prev: any) => {
            const list = [...(prev.availabilityModels || [])];
            if (!list[index]) return prev;
            list[index] = { ...list[index], [field]: value };
            return { ...prev, availabilityModels: list };
        });
    };
    const moveAvailabilityModelUp = (index: number) => {
        if (index <= 0) return;
        setData((prev: any) => {
            const list = [...(prev.availabilityModels || [])];
            [list[index - 1], list[index]] = [list[index], list[index - 1]];
            return { ...prev, availabilityModels: list };
        });
    };
    const moveAvailabilityModelDown = (index: number) => {
        const list = data.availabilityModels || [];
        if (index >= list.length - 1) return;
        setData((prev: any) => {
            const arr = [...(prev.availabilityModels || [])];
            [arr[index], arr[index + 1]] = [arr[index + 1], arr[index]];
            return { ...prev, availabilityModels: arr };
        });
    };

    const getCityName = (city: any) => {
        if (!city) return '';
        const lang = (t('lang') as string) || 'en';
        const name = city?.name;
        if (!name || typeof name !== 'object') return city?.code || '';
        return name[lang] || name.en || name.ku || name.fa || name.ar || name.tr || city?.code || '';
    };

    const getFacilityName = (facility: any) => {
        if (!facility) return '';
        const lang = (t('lang') as string) || 'en';
        const name = facility?.name;
        if (!name || typeof name !== 'object') return facility?.code || '';
        return name[lang] || name.en || name.ku || name.fa || name.ar || name.tr || facility?.code || '';
    };

    const getAttributeName = (attr: any) => {
        if (!attr) return '';
        const lang = (t('lang') as string) || 'en';
        const name = attr?.name;
        if (!name || typeof name !== 'object') return attr?.code || '';
        return name[lang] || name.en || name.ku || name.fa || name.ar || name.tr || attr?.code || '';
    };

    const setAttributeValue = (code: string, value: string) => {
        setData((prev: any) => ({
            ...prev,
            attributeValues: {
                ...(prev.attributeValues || {}),
                [code]: value
            }
        }));
    };

    const save = async () => {
        const token = cookie['token'] || cookie.token;
        if (!token) {
            Swal.fire(t("Error"), t("Please log in again."), "error");
            return;
        }
        const codeTrim = (data.code || '').trim();
        if (!codeTrim) {
            Swal.fire(t("Validation"), t("Code is required."), "warning");
            return;
        }
        if (!data.city) {
            Swal.fire(t("Validation"), t("City is required."), "warning");
            return;
        }
        const hasTitle = Object.values(data.title || {}).some(v => String(v || '').trim());
        if (!hasTitle) {
            Swal.fire(t("Validation"), t("Title is required in at least one language."), "warning");
            return;
        }
        if (data.meterSale?.enabled) {
            const total = Number(data.meterSale.totalMeters);
            const min = Number(data.meterSale.minMeters);
            const hasContract = Object.values(data.meterSale.contract?.body || {}).some((v) =>
                String(v || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/gi, ' ').trim()
            );
            if (!data.meterSale.method) {
                Swal.fire(t("Validation"), t("Sale method is required."), "warning");
                return;
            }
            if (!Number.isInteger(total) || total < 1 || !Number.isInteger(min) || min < 1 || min > total) {
                Swal.fire(t("Validation"), t("Check total meters and minimum meters."), "warning");
                return;
            }
            if (!hasContract) {
                Swal.fire(t("Validation"), t("Contract text is required in at least one language."), "warning");
                return;
            }
        }

        const body: any = {
            id: data._id,
            title: data.title,
            code: codeTrim,
            city: data.city,
            agent: data.agent || null,
            status: data.status,
            overview: data.overview,
            facilities: Array.isArray(data.facilities) ? data.facilities : [],
            mapLocation: {
                latitude: data.mapLocation?.latitude ? Number(data.mapLocation.latitude) : null,
                longitude: data.mapLocation?.longitude ? Number(data.mapLocation.longitude) : null,
                address: data.mapLocation?.address || ''
            },
            type: data.type || 'Residential',
            deliveryDate: data.deliveryDate?.month && data.deliveryDate?.year
                ? { month: Number(data.deliveryDate.month), year: Number(data.deliveryDate.year) }
                : {},
            startingPrice: Number(data.startingPrice) || 0,
            priceUnit: data.priceUnit || 'USD',
            active: data.active,
            arranged: Number(data.arranged) || 1,
            availabilityModels: Array.isArray(data.availabilityModels)
                ? data.availabilityModels.map((m: any, i: number) => ({
                    type: m.type || 'Apartment',
                    model: String(m.model ?? ''),
                    arranged: i + 1,
                    size: String(m.size ?? ''),
                    price: Number(m.price) ?? 0
                }))
                : [],
            attributeValues: data.attributeValues && typeof data.attributeValues === 'object'
                ? Object.fromEntries(
                    Object.entries(data.attributeValues).map(([k, v]) => [String(k).trim(), v === null || v === undefined ? '' : String(v)])
                  )
                : {},
            meterSale: {
                enabled: !!data.meterSale?.enabled,
                method: data.meterSale?.method || 'investment',
                totalMeters: Number(data.meterSale?.totalMeters) || 0,
                minMeters: Number(data.meterSale?.minMeters) || 1,
                contract: {
                    title: data.meterSale?.contract?.title || { ...defaultMultilingual },
                    body: data.meterSale?.contract?.body || { ...defaultMultilingual }
                }
            }
        };
        const headers = {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        };

        try {
            if (isNew) {
                await axios.post(config.url + '/v1/dashboard/realestate/properties', body, { headers });
                Swal.fire(t("Saved"), t("Property created."), "success");
            } else {
                await axios.put(config.url + '/v1/dashboard/realestate/properties/' + Id, body, { headers });
                Swal.fire(t("Saved"), t("Property updated."), "success");
            }
            navigate('/dashboard/RealEstate/properties');
        } catch (err: any) {
            const status = err?.response?.status;
            const msg = err?.response?.data?.message ?? err?.message ?? t("Could not save.");
            const fullMsg = status === 401
                ? t("Please log in again.")
                : status === 400 || status === 422
                    ? (typeof msg === 'string' ? msg : JSON.stringify(msg))
                    : err?.response?.data?.error ?? msg;
            Swal.fire(t("Error"), fullMsg, "error");
        }
    };

    const contractEditorConfig = useMemo(() => ({
        toolbar: {
            items: [
                'undo', 'redo', '|',
                'heading', '|',
                'bold', 'italic', 'underline', 'strikethrough', '|',
                'fontFamily', 'fontSize', 'fontColor', 'fontBackgroundColor', '|',
                'alignment', '|',
                'numberedList', 'bulletedList', '|',
                'link', 'blockQuote', 'insertTable', 'horizontalLine', '|',
                'removeFormat', 'sourceEditing'
            ],
            shouldNotGroupWhenFull: true,
        },
        plugins: [
            Essentials, Alignment, Bold, Italic, Underline, Strikethrough,
            Heading, Paragraph, Link, List, FontSize, FontFamily, FontColor,
            FontBackgroundColor, BlockQuote, HorizontalLine, RemoveFormat,
            SourceEditing, Table, TableToolbar, TableProperties, TableCellProperties, Undo
        ]
    }), []);

    const [activeLangTab, setActiveLangTab] = useState(languages[0]?.code || 'en');
    const [activeSectionTab, setActiveSectionTab] = useState('basic');

    if (loading) {
        return (
            <div className="text-left bg-white dark:bg-gray-900 p-3 m-4 directions min-h-[100vh] mb-5">
                <BreadCrump data={breadcrump} />
                <div className="flex items-center gap-3 py-12">
                    <div className="w-8 h-8 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
                    <p className="text-gray-500 dark:text-gray-400">{t("Loading...")}</p>
                </div>
            </div>
        );
    }

    const handleFormSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        //save();
    };

    return (
        <div className="text-left bg-gray-50 dark:bg-gray-900 p-3 m-4 directions min-h-[100vh] mb-5 overflow-y-auto">
            <BreadCrump data={breadcrump} />
            <HeaderOfPage name={isNew ? t("Add Property") : t("Edit Property")} />

            <div className="max-w-4xl mx-auto flex items-center justify-end gap-3 mb-6 sticky top-0 z-10 py-2 -mx-1 px-1 bg-gray-50/95 dark:bg-gray-900/95 backdrop-blur border-b border-gray-200 dark:border-gray-700 -mt-1">
                <button
                    type="button"
                    onClick={handleAutoTranslate}
                    title={t("Auto translate to all other languages")}
                    className="flex items-center gap-2 py-2.5 px-4 rounded-lg border border-indigo-300 dark:border-indigo-600 text-indigo-700 dark:text-indigo-300 bg-indigo-50 dark:bg-indigo-900/30 hover:bg-indigo-100 dark:hover:bg-indigo-900/50 font-medium transition-colors"
                >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
                    </svg>
                    {t("Auto translate")}
                </button>
                <button
                    type="button"
                    onClick={() => navigate('/dashboard/RealEstate/properties')}
                    className="py-2.5 px-5 rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 font-medium transition-colors"
                >
                    {t("Cancel")}
                </button>
                <button
                   onClick={() => save()}
                    form="property-form"
                    className="py-2.5 px-6 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium shadow-sm hover:shadow transition-all focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 dark:focus:ring-offset-gray-900"
                >
                    {t("Save")}
                </button>
            </div>

            <form id="property-form" onSubmit={handleFormSubmit} className="max-w-4xl mx-auto pb-24">
                <Tabs activeKey={activeSectionTab} onSelect={(k) => setActiveSectionTab(String(k ?? 'basic'))} appearance="pills">
                    <Tabs.Tab eventKey="basic" title={t("Basic information")}>
                    <div className="p-5 space-y-6">
                    <div className="rounded-xl border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800/50 p-5 space-y-4">
                        <h3 className="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider">{t("Identification")}</h3>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">{t("Code")} *</label>
                            <input
                                type="text"
                                value={data.code}
                                onChange={(e) => setData((prev: any) => ({ ...prev, code: e.target.value }))}
                                className={inputstyle}
                                placeholder={t("e.g. PROP001")}
                                disabled={!isNew}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">{t("City")} *</label>
                            <select
                                value={data.city}
                                onChange={(e) => {
                                    const cityId = e.target.value;
                                    setData((prev: any) => ({ ...prev, city: cityId }));
                                    geocodeCity(cityId);
                                }}
                                className={inputstyle}
                            >
                                <option value="">{t("Select City")}</option>
                                {cities.map((city: any) => (
                                    <option key={city._id} value={city._id}>{getCityName(city)}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">{t("Agent")}</label>
                            <select
                                value={data.agent || ''}
                                onChange={(e) => setData((prev: any) => ({ ...prev, agent: e.target.value }))}
                                className={inputstyle}
                            >
                                <option value="">{t("No agent")}</option>
                                {agents.map((agent: any) => (
                                    <option key={agent._id} value={agent._id}>
                                        {[agent.name, agent.lastname].filter(Boolean).join(' ') || agent.email || agent.phone || agent._id}
                                    </option>
                                ))}
                            </select>
                        </div>
                        </div>
                    </div>
                    <div className="rounded-xl border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800/50 p-5 space-y-4">
                        <h3 className="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider">{t("Type & status")}</h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">{t("Status")}</label>
                            <select
                                value={data.status}
                                onChange={(e) => setData((prev: any) => ({ ...prev, status: e.target.value }))}
                                className={inputstyle}
                            >
                                {STATUS_OPTIONS.map(status => (
                                    <option key={status} value={status}>{t(status)}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">{t("Type")}</label>
                            <select
                                value={TYPE_OPTIONS.includes(data.type) ? data.type : 'Other'}
                                onChange={(e) => setData((prev: any) => ({
                                    ...prev,
                                    type: e.target.value === 'Other' ? '' : e.target.value
                                }))}
                                className={inputstyle}
                            >
                                {TYPE_OPTIONS.map(type => (
                                    <option key={type} value={type}>{t(type)}</option>
                                ))}
                            </select>
                            {(!data.type || !TYPE_OPTIONS.includes(data.type)) && (
                                <input
                                    type="text"
                                    value={data.type}
                                    onChange={(e) => setData((prev: any) => ({ ...prev, type: e.target.value }))}
                                    className={`${inputstyle} mt-2`}
                                    placeholder={t("e.g. Villa, Apartment")}
                                />
                            )}
                        </div>
                        </div>
                    </div>
                    <div className="rounded-xl border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800/50 p-5 space-y-4">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">{t("Title")} *</label>
                        <div className="flex gap-1 p-1 bg-gray-100 dark:bg-gray-700/50 rounded-lg mb-3 overflow-x-auto">
                            {languages.map(lang => (
                                <button
                                    key={lang.code}
                                    type="button"
                                    onClick={() => setActiveLangTab(lang.code)}
                                    className={`px-4 py-2 rounded-md text-sm font-medium transition-all whitespace-nowrap ${
                                        activeLangTab === lang.code
                                            ? 'bg-white dark:bg-gray-800 text-blue-600 dark:text-blue-400 shadow-sm'
                                            : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
                                    }`}
                                >
                                    {lang.label}
                                </button>
                            ))}
                        </div>
                        <AnimatePresence mode="wait">
                            {languages.map(lang => activeLangTab === lang.code && (
                                <motion.div
                                    key={lang.code}
                                    initial={{ opacity: 0, x: -8 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    exit={{ opacity: 0, x: 8 }}
                                    transition={{ duration: 0.15 }}
                                >
                                    <input
                                        type="text"
                                        value={data.title[lang.code] ?? ''}
                                        onChange={(e) => setMultilingualField('title', lang.code, e.target.value)}
                                        className={inputstyle}
                                        placeholder={`${t("Title")} (${lang.label})`}
                                    />
                                </motion.div>
                            ))}
                        </AnimatePresence>
                    </div>
                    <div className="rounded-xl border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800/50 p-5 space-y-4">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">{t("Overview")}</label>
                        <AnimatePresence mode="wait">
                            {languages.map(lang => activeLangTab === lang.code && (
                                <motion.div
                                    key={lang.code}
                                    initial={{ opacity: 0, x: -8 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    exit={{ opacity: 0, x: 8 }}
                                    transition={{ duration: 0.15 }}
                                >
                                    <textarea
                                        value={data.overview[lang.code] ?? ''}
                                        onChange={(e) => setMultilingualField('overview', lang.code, e.target.value)}
                                        className={textareastyle}
                                        placeholder={`${t("Overview")} (${lang.label})`}
                                    />
                                </motion.div>
                            ))}
                        </AnimatePresence>
                    </div>
                    <div className="rounded-xl border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800/50 p-5 space-y-4">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">{t("Map Location")}</label>
                        <MapPicker
                            latitude={data.mapLocation?.latitude || null}
                            longitude={data.mapLocation?.longitude || null}
                            onLocationChange={handleMapLocationChange}
                        />
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5 mt-3">{t("Address")}</label>
                        <textarea
                            value={data.mapLocation?.address || ''}
                            onChange={(e) => setData((prev: any) => ({
                                ...prev,
                                mapLocation: { ...prev.mapLocation, address: e.target.value }
                            }))}
                            className={textareastyle}
                            placeholder={t("Street address")}
                            rows={2}
                        />
                        {data.mapLocation?.latitude && data.mapLocation?.longitude && (
                            <a
                                href={`https://www.openstreetmap.org/?mlat=${data.mapLocation.latitude}&mlon=${data.mapLocation.longitude}&zoom=15`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-2 text-sm text-blue-600 dark:text-blue-400 hover:underline mt-2"
                            >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                </svg>
                                {t("View on OpenStreetMap")}
                            </a>
                        )}
                    </div>
                    <div className="rounded-xl border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800/50 p-5 space-y-4">
                        <h3 className="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider">{t("Visibility & order")}</h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <label className="flex items-center gap-3 p-4 rounded-lg border border-gray-200 dark:border-gray-600 cursor-pointer hover:border-gray-300 dark:hover:border-gray-500 transition-colors">
                            <input
                                type="checkbox"
                                checked={data.active}
                                onChange={(e) => setData((prev: any) => ({ ...prev, active: e.target.checked }))}
                                className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 w-5 h-5"
                            />
                            <div>
                                <span className="text-sm font-medium text-gray-700 dark:text-gray-300">{t("Active")}</span>
                                <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{t("Show this property to users")}</p>
                            </div>
                        </label>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">{t("Display order")}</label>
                            <div className="flex items-stretch rounded-lg border border-gray-200 dark:border-gray-600 overflow-hidden bg-white dark:bg-gray-800">
                                <button
                                    type="button"
                                    title={t("Move up (decrease number)")}
                                    onClick={() => setData((prev: any) => ({ ...prev, arranged: Math.max(0, (prev.arranged ?? 1) - 1) }))}
                                    className="flex items-center justify-center w-11 border-r border-gray-200 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                                >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" /></svg>
                                </button>
                                <input
                                    type="number"
                                    min={0}
                                    value={data.arranged}
                                    onChange={(e) => setData((prev: any) => ({ ...prev, arranged: Math.max(0, parseInt(e.target.value, 10) || 0) }))}
                                    className="flex-1 min-w-0 w-20 py-2.5 px-3 text-center border-0 bg-transparent text-sm focus:ring-2 focus:ring-blue-500/20 focus:ring-inset dark:bg-transparent"
                                />
                                <button
                                    type="button"
                                    title={t("Move down (increase number)")}
                                    onClick={() => setData((prev: any) => ({ ...prev, arranged: (prev.arranged ?? 0) + 1 }))}
                                    className="flex items-center justify-center w-11 border-l border-gray-200 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                                >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
                                </button>
                            </div>
                            <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">{t("Lower number = higher in list")}</p>
                        </div>
                        </div>
                    </div>
                    </div>
                    </Tabs.Tab>

                    <Tabs.Tab eventKey="facilities" title={t("Facilities")}>
                    <div className="p-5 space-y-8">
                    <div>
                        <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3">{t("Facilities")}</h3>
                        {facilities.length === 0 ? (
                            <p className="text-sm text-gray-500 dark:text-gray-400 py-4">{t("No facilities available.")}</p>
                        ) : (
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 max-h-56 overflow-y-auto pr-1">
                                {facilities.map((facility: any) => (
                                    <label
                                        key={facility._id}
                                        className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-all ${
                                            data.facilities?.includes(facility._id)
                                                ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20 dark:border-blue-600'
                                                : 'border-gray-200 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500'
                                        }`}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={data.facilities?.includes(facility._id)}
                                            onChange={() => toggleFacility(facility._id)}
                                            className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 w-4 h-4"
                                        />
                                        <span className="text-sm font-medium text-gray-700 dark:text-gray-300">{getFacilityName(facility)}</span>
                                        <span className="text-xs text-gray-500 dark:text-gray-400">({facility.code})</span>
                                    </label>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="border-t border-gray-200 dark:border-gray-600 pt-6">
                        <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">{t("Property Data (Attributes)")}</h3>
                        <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">{t("Fill in values for each attribute (e.g. total area, number of floors).")}</p>
                        {attributes.length === 0 ? (
                            <p className="text-sm text-gray-500 dark:text-gray-400 py-4">{t("No attributes defined. Add attributes in Attribute Management first.")}</p>
                        ) : (
                            <div className="space-y-4">
                                {attributes.filter((a: any) => a.active !== false).map((attr: any) => (
                                    <div key={attr._id} className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                                        <label className="sm:w-56 flex-shrink-0 text-sm font-medium text-gray-700 dark:text-gray-300">
                                            {getAttributeName(attr)}
                                        </label>
                                        <input
                                            type="text"
                                            value={(data.attributeValues || {})[attr.code] ?? ''}
                                            onChange={(e) => setAttributeValue(attr.code, e.target.value)}
                                            className={inputstyle}
                                            placeholder={t("e.g. 150 m², 5 floors")}
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    </div>
                    </Tabs.Tab>

                    <Tabs.Tab eventKey="availability" title={t("Availability Models")}>
                    <div className="p-5 space-y-4">
                        <div className="flex items-center justify-between mb-3">
                            <p className="text-sm text-gray-600 dark:text-gray-400">{t("Add models (e.g. Apartment, MarketPlace) assigned to this property.")}</p>
                            <button
                                type="button"
                                onClick={addAvailabilityModel}
                                className="py-2 px-4 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium"
                            >
                                + {t("Add Model")}
                            </button>
                        </div>
                        {availabilityModels.length === 0 ? (
                            <p className="text-sm text-gray-500 dark:text-gray-400 py-6 text-center border border-dashed border-gray-300 dark:border-gray-600 rounded-lg">
                                {t("No availability models. Click \"Add Model\" to add one.")}
                            </p>
                        ) : (
                            <div className="space-y-3 overflow-x-auto">
                                {availabilityModels.map((row: any, index: number) => (
                                    <div
                                        key={index}
                                        className="p-4 rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 space-y-3"
                                    >
                                        <div className="flex items-center justify-between gap-2 flex-wrap">
                                            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">{t("Model")} #{index + 1}</span>
                                            <div className="flex items-center gap-2">
                                                <button
                                                    type="button"
                                                    title={t("Move up")}
                                                    onClick={() => moveAvailabilityModelUp(index)}
                                                    disabled={index === 0}
                                                    className="p-1.5 rounded border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-40 disabled:pointer-events-none"
                                                >
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" /></svg>
                                                </button>
                                                <button
                                                    type="button"
                                                    title={t("Move down")}
                                                    onClick={() => moveAvailabilityModelDown(index)}
                                                    disabled={index === availabilityModels.length - 1}
                                                    className="p-1.5 rounded border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-40 disabled:pointer-events-none"
                                                >
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={() => removeAvailabilityModel(index)}
                                                    className="text-red-600 dark:text-red-400 hover:underline text-sm"
                                                >
                                                    {t("Remove")}
                                                </button>
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
                                            <div>
                                                <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">{t("Type")}</label>
                                                <select
                                                    value={row.type || 'Apartment'}
                                                    onChange={(e) => updateAvailabilityModel(index, 'type', e.target.value)}
                                                    className={inputstyle}
                                                >
                                                    {AVAILABILITY_MODEL_TYPES.map((opt) => (
                                                        <option key={opt} value={opt}>{t(opt)}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div>
                                                <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">{t("Model")}</label>
                                                <input
                                                    type="text"
                                                    value={row.model ?? ''}
                                                    onChange={(e) => updateAvailabilityModel(index, 'model', e.target.value)}
                                                    className={inputstyle}
                                                    placeholder={t("Model name")}
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">{t("Order")}</label>
                                                <div className={`${inputstyle} flex items-center`}>{index + 1}</div>
                                            </div>
                                            <div>
                                                <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">{t("Size")}</label>
                                                <input
                                                    type="text"
                                                    value={row.size ?? ''}
                                                    onChange={(e) => updateAvailabilityModel(index, 'size', e.target.value)}
                                                    className={inputstyle}
                                                    placeholder={t("e.g. 120 sqm")}
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">{t("Price")}</label>
                                                <CurrencyInput
                                                    value={row.price != null && row.price !== '' ? String(row.price) : ''}
                                                    onValueChange={(value: string | undefined) => updateAvailabilityModel(index, 'price', value === undefined || value === '' ? 0 : value)}
                                                    placeholder={t("0")}
                                                    allowNegativeValue={false}
                                                    decimalsLimit={2}
                                                    prefix={CURRENCY_OPTIONS.find(c => c.value === (data.priceUnit || 'USD'))?.prefix}
                                                    suffix={CURRENCY_OPTIONS.find(c => c.value === (data.priceUnit || 'USD'))?.suffix}
                                                    groupSeparator=","
                                                    decimalSeparator="."
                                                    className={inputstyle}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    </Tabs.Tab>

                    <Tabs.Tab eventKey="images" title={t("Images")}>
                    <div className="p-5 space-y-4">
                    <ImageUploader id={Id ?? ''} component="Property" />
                    <ImageUploaders id={Id ?? ''} component="PropertyImages" />
                    </div>
                    </Tabs.Tab>

                    <Tabs.Tab eventKey="videos" title={t("Videos")}>
                    <div className="p-5 space-y-4">
                    <VideoUploaders id={Id ?? ''} component="PropertyVideos" />
                    </div>
                    </Tabs.Tab>

                    <Tabs.Tab eventKey="documents" title={t("Documents")}>
                    <div className="p-5 space-y-4">
                        <p className="text-sm text-gray-500 dark:text-gray-400">
                            {t("Upload property brochures, floor plans, permits, and other files.")}
                        </p>
                        <DocumentsUploader id={Id ?? ''} component="PropertyDocuments" />
                    </div>
                    </Tabs.Tab>

                    <Tabs.Tab eventKey="pricing" title={t("Delivery & Pricing")}>
                    <div className="p-5 space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">{t("Delivery Date")}</label>
                            <div className="grid grid-cols-2 gap-2">
                                <select
                                    value={data.deliveryDate?.month || ''}
                                    onChange={(e) => setData((prev: any) => ({
                                        ...prev,
                                        deliveryDate: { ...prev.deliveryDate, month: e.target.value ? Number(e.target.value) : null }
                                    }))}
                                    className={inputstyle}
                                >
                                    <option value="">{t("Month")}</option>
                                    {MONTHS.map(m => (
                                        <option key={m.value} value={m.value}>{t(m.label)}</option>
                                    ))}
                                </select>
                                <select
                                    value={data.deliveryDate?.year || ''}
                                    onChange={(e) => setData((prev: any) => ({
                                        ...prev,
                                        deliveryDate: { ...prev.deliveryDate, year: e.target.value ? Number(e.target.value) : null }
                                    }))}
                                    className={inputstyle}
                                >
                                    <option value="">{t("Year")}</option>
                                    {Array.from({ length: 51 }, (_, i) => 2010 + i).map(y => (
                                        <option key={y} value={y}>{y}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">{t("Price Unit")}</label>
                            <select
                                value={data.priceUnit || 'USD'}
                                onChange={(e) => setData((prev: any) => ({ ...prev, priceUnit: e.target.value }))}
                                className={inputstyle}
                            >
                                {CURRENCY_OPTIONS.map(c => (
                                    <option key={c.value} value={c.value}>{c.label}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">{t("Starting Price")}</label>
                        <CurrencyInput
                            value={data.startingPrice != null && data.startingPrice !== '' ? String(data.startingPrice) : ''}
                            onValueChange={(value: string | undefined) => setData((prev: any) => ({
                                ...prev,
                                startingPrice: value === undefined || value === '' ? 0 : value
                            }))}
                            placeholder={t("0")}
                            allowNegativeValue={false}
                            disableAbbreviations={false}
                            decimalsLimit={CURRENCY_OPTIONS.find(c => c.value === (data.priceUnit || 'USD'))?.decimalsLimit ?? 2}
                            prefix={CURRENCY_OPTIONS.find(c => c.value === (data.priceUnit || 'USD'))?.prefix}
                            suffix={CURRENCY_OPTIONS.find(c => c.value === (data.priceUnit || 'USD'))?.suffix}
                            groupSeparator=","
                            decimalSeparator="."
                            className={inputstyle}
                        />
                    </div>
                    </div>
                    </Tabs.Tab>

                    <Tabs.Tab eventKey="meterSales" title={t("Meter sales")}>
                    <div className="p-5 space-y-6">
                        <div className="rounded-xl border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800/50 p-5 space-y-4">
                            <label className="flex items-center gap-3 text-sm font-medium text-gray-700 dark:text-gray-300">
                                <input
                                    type="checkbox"
                                    checked={!!data.meterSale?.enabled}
                                    onChange={(e) => setData((prev: any) => ({
                                        ...prev,
                                        meterSale: { ...prev.meterSale, enabled: e.target.checked }
                                    }))}
                                />
                                {t("Enable meter sales")}
                            </label>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">{t("Sale method")}</label>
                                    <select
                                        value={data.meterSale?.method || 'investment'}
                                        onChange={(e) => setData((prev: any) => ({
                                            ...prev,
                                            meterSale: { ...prev.meterSale, method: e.target.value }
                                        }))}
                                        className={inputstyle}
                                    >
                                        <option value="investment">{t("Investment")}</option>
                                        <option value="residential_session">{t("Residential session")}</option>
                                    </select>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">{t("Total meters")}</label>
                                    <input
                                        type="number"
                                        min={1}
                                        step={1}
                                        value={data.meterSale?.totalMeters ?? 0}
                                        onChange={(e) => setData((prev: any) => ({
                                            ...prev,
                                            meterSale: { ...prev.meterSale, totalMeters: e.target.value === '' ? 0 : Number(e.target.value) }
                                        }))}
                                        className={inputstyle}
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">{t("Minimum meters")}</label>
                                    <input
                                        type="number"
                                        min={1}
                                        step={1}
                                        value={data.meterSale?.minMeters ?? 1}
                                        onChange={(e) => setData((prev: any) => ({
                                            ...prev,
                                            meterSale: { ...prev.meterSale, minMeters: e.target.value === '' ? 1 : Number(e.target.value) }
                                        }))}
                                        className={inputstyle}
                                    />
                                </div>
                            </div>
                            <p className="text-xs text-gray-500 dark:text-gray-400">
                                {t("Contract version")}: {data.meterSale?.contract?.version || 1}. {t("One method per project. No price on this plan.")}
                            </p>
                        </div>
                        <div className="rounded-xl border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800/50 p-5 space-y-4">
                            <h3 className="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider">{t("Contract")}</h3>
                            <Tabs appearance="subtle">
                                {languages.map((lang) => (
                                    <Tabs.Tab key={lang.code} eventKey={lang.code} title={lang.label}>
                                        <div className="space-y-3 pt-3">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">{t("Contract title")}</label>
                                                <input
                                                    type="text"
                                                    value={data.meterSale?.contract?.title?.[lang.code] ?? ''}
                                                    onChange={(e) => setData((prev: any) => ({
                                                        ...prev,
                                                        meterSale: {
                                                            ...prev.meterSale,
                                                            contract: {
                                                                ...prev.meterSale.contract,
                                                                title: { ...prev.meterSale.contract.title, [lang.code]: e.target.value }
                                                            }
                                                        }
                                                    }))}
                                                    className={inputstyle}
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">{t("Contract text")}</label>
                                                <div className="border border-gray-200 dark:border-gray-600 rounded-lg overflow-hidden bg-white" dir={['fa', 'ar', 'ku'].includes(lang.code) ? 'rtl' : 'ltr'}>
                                                    <CKEditor
                                                        key={`contract-body-${lang.code}`}
                                                        editor={ClassicEditor}
                                                        // @ts-ignore
                                                        config={contractEditorConfig}
                                                        data={data.meterSale?.contract?.body?.[lang.code] ?? ''}
                                                        onChange={(_event: any, editor: any) => {
                                                            const html = editor.getData();
                                                            setData((prev: any) => ({
                                                                ...prev,
                                                                meterSale: {
                                                                    ...prev.meterSale,
                                                                    contract: {
                                                                        ...prev.meterSale.contract,
                                                                        body: { ...prev.meterSale.contract.body, [lang.code]: html }
                                                                    }
                                                                }
                                                            }));
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </Tabs.Tab>
                                ))}
                            </Tabs>
                        </div>
                    </div>
                    </Tabs.Tab>

                    <Tabs.Tab eventKey="contentEditor" title={t("Content Editor")}>
                    <div className="p-5 space-y-4">
                    <TissEditor 
                       parent={Id}
                       component="PropertyContent"
                        
                    />
                    </div>
                    </Tabs.Tab>
                </Tabs>
            </form>
        </div>
    );
}
